import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import Select from 'react-select'
import classnames from 'classnames'

class SelectPicker extends Component {
    render() {
        const {
            options,
            extraLight,
            isSearchable = false,
            ...other
        } = this.props
        return (
            <Select
                className={classnames('select-picker', {
                    'extra-light': extraLight,
                })}
                classNamePrefix="select"
                isSearchable={isSearchable}
                options={options}
                {...other}
            />
        )
    }
}

export default SelectPicker



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/SelectPicker.jsx